import { render, staticRenderFns } from "./Ids.vue?vue&type=template&id=d69a65c6&"
import script from "./Ids.vue?vue&type=script&lang=js&"
export * from "./Ids.vue?vue&type=script&lang=js&"
import style0 from "./Ids.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports